const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Guards Hasura calls that filter/authorize on a uuid column (e.g. tenantId) — those columns
// reject anything else with an unhandled GraphQL error, so callers should check this first.
export function isValidUuid(value: string | null | undefined): boolean {
  return typeof value === "string" && UUID_PATTERN.test(value);
}
